import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import DashboardComponent from './DashboardComponent';
import AlarmSettings from './AlarmSettings';
// import Login from './Login';
// function ProtectedRoute({ children }) {
//   const token = localStorage.getItem('token');
//   if (!token) {
//     window.location.href = '/login';
//     return null;
//   }
//   return children;
// }

function App() {
  return (
    <Router>
      <nav style={{
        padding: '24px 40px',
        background: '#fafbfc',
        display: 'flex',
        gap: 32,
        borderBottom: '1px solid #eee',
        alignItems: 'center',
        fontSize: 20,
        fontWeight: 600
      }}>
        <Link to="/" style={{
          color: '#2c3e50',
          textDecoration: 'none',
          padding: '6px 18px',
          borderRadius: 8,
          transition: 'background 0.2s, color 0.2s',
          marginRight: 12
        }}>Dashboard</Link>
        <Link to="/settings" style={{
          color: '#2c3e50',
          textDecoration: 'none',
          padding: '6px 18px',
          borderRadius: 8,
          transition: 'background 0.2s, color 0.2s',
        }}>Alarm settings</Link>
      </nav>
      <Routes>
        {/* <Route path="/login" element={<Login onLogin={() => window.location.href = '/'} />} /> */}
        <Route path="/" element={<DashboardComponent />} />
        <Route path="/settings" element={<AlarmSettings />} />
      </Routes>
    </Router>
  );
}

export default App;
